import { render, staticRenderFns } from "./ActivityRecordDetailTable.vue?vue&type=template&id=f95edbb8&scoped=true&"
import script from "./ActivityRecordDetailTable.vue?vue&type=script&lang=js&"
export * from "./ActivityRecordDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./ActivityRecordDetailTable.vue?vue&type=style&index=0&id=f95edbb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95edbb8",
  null
  
)

export default component.exports